module.exports = __webpack_public_path__ + "media/images/resources-item-new-1168eb416a675f3921e2174caf31c15e.svg";